module.exports = __webpack_public_path__ + "img/gb9116_18_c.prt.86dd4f81.jpg";